import { createRouter, createWebHistory } from 'vue-router'

import { handleAdminToken, checkToken } from '@/router/config/configRoutes'
import nextFactory from '@/router/middleware/nextFactory'

import { BASE_ROUTES } from '@/router/config/baseRoutes'

import { useAppStore } from '@/store/appStore'
import { useAuthorizationStore } from '@/store/authorizationStore'
import { usePermissionsStore } from '@/store/permissionsStore'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: BASE_ROUTES,
})

router.beforeEach(async (to, from, next) => {
    const authorizationStore = useAuthorizationStore()
    const permissionsStore = usePermissionsStore()
    const appStore = useAppStore()

    appStore.setRouteLoading(true)

    await handleAdminToken(to.query)
    await checkToken(to, next, authorizationStore)

    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware]

        const context = {
            to,
            from,
            next,
            store: authorizationStore,
            permissionsStore,
            router,
        }

        const nextMiddleware = nextFactory(context, middleware, 1)

        return middleware[0]({ ...context, next: nextMiddleware })
            .then(() => next())
            .catch((error) => {
                next(error)
            })
    }

    return next()
})

router.onError((error, to) => {
    if (import.meta.env.VITE_NODE_ENV !== 'local') {
        window.open(to.path, '_self')
    } else {
        console.warn('Router error in local env:', error)
    }
})

router.beforeResolve(() => {
    const appStore = useAppStore()
    appStore.setRouteLoading(false)
})

export default router
